import { render } from "./apply_categories.vue?vue&type=template&id=9976ad98&scoped=true&ts=true"
import script from "./apply_categories.vue?vue&type=script&lang=ts"
export * from "./apply_categories.vue?vue&type=script&lang=ts"

import "./apply_categories.vue?vue&type=style&index=0&id=9976ad98&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9976ad98"]])

export default __exports__